// @flow
import React from 'react';
import {
  DateTime,
} from 'luxon';
import * as utils from 'chronos-utils';

import type {
  Worklog,
  IntervalType,
} from 'chronos-types';

import {
  Cell,
  CellData,
} from './styled';

type Worklogs = {
  [string]: {
    [string]: Worklog,
  }
}

type Props = {
  style: Object,
  columnIndex: number,
  rowIndex: number,
  fetching: boolean,
  selectedRows: [],
  selectedColumns: [],
  worklogs: Worklogs,
  columnIndex: number,
  currentDate: IntervalType,
  sidebarItems: Array<Object>,
};

function calculateDelay(rowIndex, columnIndex) {
  const x = columnIndex + rowIndex;
  return x / (Math.abs(x) + 10);
}

function getGridType(props: Props) {
  const { total, columnIndex, currentDate } = props;

  const cellDate = currentDate.start.plus({ days: columnIndex });
  if (total) return 'populated';
  if (cellDate.hasSame(DateTime.local(), 'day')) return 'today';
  if (/^(6|7)$/.test(cellDate.weekday)) return 'week';
  return '';
}

const GridCellRenderer = ({
  style,
  worklogs,
  columnIndex,
  currentDate,
  rowIndex,
  fetching,
  selectedColumns,
  sidebarItems,
  selectedRows,
}: Props) => {
  const highlight = selectedRows.length > 0 || selectedColumns.length > 0;
  const item = sidebarItems[rowIndex] || {};
  const date = currentDate.start.plus({ days: columnIndex });
  const selected = selectedRows.includes(item.id) || selectedColumns.some(d => d.hasSame(date, 'day'));
  const worklog = (worklogs && worklogs[date.toFormat('yyyy-MM-dd')]) || {};
  const total = worklog[item.id]
    ? worklog[item.id].timeSpentSeconds
    : null;
  return (
    <Cell
      type={getGridType({ total, columnIndex, currentDate })}
      style={style}
      delay={`${calculateDelay(rowIndex, columnIndex)}s`}
      fetching={fetching}
      highlight={highlight && !selected}
    >
      {total && <CellData>{utils.stj(total)}</CellData>}
    </Cell>
  );
};

GridCellRenderer.defaultProps = {
  worklog: null,
};

export default GridCellRenderer;
